import { controls } from "../../controls";

const rp602 = {
  label: "Limit Sanction for SSK",
  pageLabel: "Limit Sanction for SSK",
  starting: true,
  url: "rp602",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "filter", label: "Taluka", width: "col-sm-2" }),
    ...controls.Taluka({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "taluka_display", name: "taluka_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),


    ...controls.displayText({ tab: "filter", label: "As on Date", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter' }),
  ],

  //form: [
  //  ...controls.displayText({ label: "Crop Type Code", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //  ...controls.displayText({ label: "Crop Type Desc", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type_display", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //],
  form: [],

  history: {
    perPage: 10,
    reportHeader: "Limit Sanction for SSK",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },


    extraRows: {
      fields: ["consortium_loan", "restructured_term_loan", "outstanding_principal", "outstanding_interest", "principal_overdue", "interest"],
      subtotals: {
        by: "descn",
        displayIn: "descn",
        groupsOnly: false,
        location: "bottom",
      },
      grandtotal: { type: "fixed", displayIn: "descn", val: "Grand Total", count: true },
      // fixedTotals:[{by:"rows",rows:[1,2,3]}]
    },


    displayColumns: [

      {
        Header: "Name of SSK",
        accessor: "descn",
        width: 300,
        rwidth: "*"
      },
      {
        Header: "Limit Sanctioned",
        columns: [
          {
            Header: "Consortium Loan",
            accessor: "consortium_loan",
            type: "currency",
            rwidth: "*"
          },
          {
            Header: "Restructured Term Loan",
            accessor: "restructured_term_loan",
            type: "currency",
            rwidth: "*"
          }

        ]
      },
      {
        Header: "Outstanding Principal",
        accessor: "outstanding_principal",
        type: "currency",
        rwidth: "*"
      },
      {
        Header: "Outstanding Interest",
        accessor: "outstanding_interest",
        type: "currency",
        rwidth: "*"
      },
      {
        Header: "Principal Overdue",
        accessor: "principal_overdue",
        type: "currency",
        rwidth: "*"
      },
      {
        Header: "Interest",
        accessor: "interest",
        type: "currency",
        rwidth: "*"
      }
    ]
  }
};

export default rp602;